import { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  setEnglishPositiveResponse,
  setEnglishNegativeResponse,
  setSpanishPositiveResponse,
  setSpanishNegativeResponse,
} from '../../store/ResponseCreate/actionCreator'
import { TextField, withStyles } from '@material-ui/core'
import { formValidation } from '../MessageCreate/formValidation'
import { object, string, func, bool } from 'prop-types'

const styles = (theme) => ({
  formBox: {
    textAlign: 'center',
  },
  button: {
    marginLeft: 15,
  },
  textField: {
    width: '90%',
  },
})

export class ResponseCreateForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      englishPositiveResponse: this.props.fromParentEnglishPositiveResponseData,
      englishPositiveResponseErrorMsg: formValidation(
        this.props.fromParentEnglishPositiveResponseData,
        'text',
        'text',
      ),
      englishPositiveResponseError: formValidation(
        this.props.fromParentEnglishPositiveResponseData,
        'text',
        'boolean',
      ),
      englishNegativeResponse: this.props.fromParentEnglishNegativeResponseData,
      englishNegativeResponseErrorMsg: formValidation(
        this.props.fromParentEnglishNegativeResponseData,
        'text',
        'text',
      ),
      englishNegativeResponseError: formValidation(
        this.props.fromParentEnglishNegativeResponseData,
        'text',
        'boolean',
      ),
      spanishPositiveResponse: this.props.fromParentSpanishPositiveResponseData,
      spanishPositiveResponseErrorMsg: formValidation(
        this.props.fromParentSpanishPositiveResponseData,
        'text',
        'text',
      ),
      spanishPositiveResponseError: formValidation(
        this.props.fromParentSpanishPositiveResponseData,
        'text',
        'boolean',
      ),
      spanishNegativeResponse: this.props.fromParentSpanishNegativeResponseData,
      spanishNegativeResponseErrorMsg: formValidation(
        this.props.fromParentSpanishNegativeResponseData,
        'text',
        'text',
      ),
      spanishNegativeResponseError: formValidation(
        this.props.fromParentSpanishNegativeResponseData,
        'text',
        'boolean',
      ),
      notifySelected: this.props.fromParentNotify,
      languageSelected: this.props.fromParentLanguageSelectedResponse,
    }
    this.handleChange = this.handleChange.bind(this)
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { fromParentLanguageSelectedResponse } = this.props
    const {
      fromParentLanguageSelectedResponse:
        nextFromParentLanguageSelectedResponse,
    } = nextProps

    if (
      fromParentLanguageSelectedResponse !==
      nextFromParentLanguageSelectedResponse
    ) {
      this.setState({
        languageSelected: nextProps.fromParentLanguageSelectedResponse,
        englishPositiveResponseErrorMsg: formValidation(
          this.state.englishPositiveResponse,
          'text',
          'text',
        ),
        englishPositiveResponseError: formValidation(
          this.state.englishPositiveResponse,
          'text',
          'boolean',
        ),
        englishNegativeResponseErrorMsg: formValidation(
          this.state.englishNegativeResponse,
          'text',
          'text',
        ),
        englishNegativeResponseError: formValidation(
          this.state.englishNegativeResponse,
          'text',
          'boolean',
        ),
        spanishPositiveResponseErrorMsg: formValidation(
          this.state.spanishPositiveResponse,
          'text',
          'text',
        ),
        spanishPositiveResponseError: formValidation(
          this.state.spanishPositiveResponse,
          'text',
          'boolean',
        ),
        spanishNegativeResponseErrorMsg: formValidation(
          this.state.spanishNegativeResponse,
          'text',
          'text',
        ),
        spanishNegativeResponseError: formValidation(
          this.state.spanishNegativeResponse,
          'text',
          'boolean',
        ),
      })
    }
  }

  handlePreviewOutput(languageTextObject) {
    let returnVar = ''
    if (languageTextObject.englishPositiveResponse) {
      returnVar =
        returnVar +
        this.state.englishPositiveResponse +
        ' https://r.tgt.com/12345\n\n'
    }
    if (languageTextObject.englishNegativeResponse) {
      returnVar =
        returnVar +
        this.state.englishNegativeResponse +
        ' https://r.tgt.com/abcde'
    }
    if (languageTextObject.spanishPositiveResponse) {
      returnVar =
        returnVar +
        '\n\n\n' +
        this.state.spanishPositiveResponse +
        ' https://r.tgt.com/12345\n\n'
    }
    if (languageTextObject.spanishNegativeResponse) {
      returnVar =
        returnVar +
        this.state.spanishNegativeResponse +
        ' https://r.tgt.com/abcde'
    }
    return returnVar
  }

  handleChange(event) {
    const target = event.target
    const value = target.type === 'checkbox' ? target.checked : target.value
    const name = target.name
    const {
      callbackFromParentEnglishPositiveResponse,
      callbackFromParentEnglishPositiveResponseData,
      callbackFromParentEnglishNegativeResponse,
      callbackFromParentEnglishNegativeResponseData,
      callbackFromParentSpanishPositiveResponse,
      callbackFromParentSpanishPositiveResponseData,
      callbackFromParentSpanishNegativeResponse,
      callbackFromParentSpanishNegativeResponseData,
    } = this.props

    this.setState({
      [name]: value,
    })
    if (name === 'englishPositiveResponse') {
      this.setState({
        englishPositiveResponseError: formValidation(value, 'text', 'boolean'),
      })
      callbackFromParentEnglishPositiveResponse(
        formValidation(value, 'text', 'boolean'),
      )
      this.setState({
        englishPositiveResponseErrorMsg: formValidation(value, 'text', 'text'),
      })
      callbackFromParentEnglishPositiveResponseData(value)
    }
    if (name === 'englishNegativeResponse') {
      this.setState({
        englishNegativeResponseError: formValidation(value, 'text', 'boolean'),
      })
      callbackFromParentEnglishNegativeResponse(
        formValidation(value, 'text', 'boolean'),
      )
      this.setState({
        englishNegativeResponseErrorMsg: formValidation(value, 'text', 'text'),
      })
      callbackFromParentEnglishNegativeResponseData(value)
    }
    if (name === 'spanishPositiveResponse') {
      setSpanishPositiveResponse(value)
      this.setState({
        spanishPositiveResponseError: formValidation(value, 'text', 'boolean'),
      })
      callbackFromParentSpanishPositiveResponse(
        formValidation(value, 'text', 'boolean'),
      )
      this.setState({
        spanishPositiveResponseErrorMsg: formValidation(value, 'text', 'text'),
      })
      callbackFromParentSpanishPositiveResponseData(value)
    }
    if (name === 'spanishNegativeResponse') {
      setSpanishNegativeResponse(value)
      this.setState({
        spanishNegativeResponseError: formValidation(value, 'text', 'boolean'),
      })
      callbackFromParentSpanishNegativeResponse(
        formValidation(value, 'text', 'boolean'),
      )
      this.setState({
        spanishNegativeResponseErrorMsg: formValidation(value, 'text', 'text'),
      })
      callbackFromParentSpanishNegativeResponseData(value)
    }
  }

  render() {
    let englishPositiveResponseField = ''
    let englishNegativeResponseField = ''
    let spanishPositiveResponseField = ''
    let spanishNegativeResponseField = ''
    let previewField = ''
    const { classes } = this.props
    if (this.state.notifySelected === false) {
      englishPositiveResponseField = (
        <TextField
          name="englishPositiveResponse"
          id="message_response_positive"
          label="Positive Response - English"
          multiline
          minRows="2"
          margin="normal"
          value={this.state.englishPositiveResponse}
          onChange={this.handleChange.bind(this)}
          className={classes.textField}
          error={this.state.englishPositiveResponseError}
          helperText={this.state.englishPositiveResponseErrorMsg}
        />
      )
      englishNegativeResponseField = (
        <TextField
          name="englishNegativeResponse"
          id="message_response_negative"
          label="Negative Response - English"
          multiline
          minRows="2"
          margin="normal"
          value={this.state.englishNegativeResponse}
          onChange={this.handleChange.bind(this)}
          className={classes.textField}
          error={this.state.englishNegativeResponseError}
          helperText={this.state.englishNegativeResponseErrorMsg}
        />
      )
      previewField = (
        <TextField
          disabled
          id="response-message-preview"
          label="Response Message Preview"
          value={this.handlePreviewOutput({
            englishPositiveResponse: this.state.englishPositiveResponse,
            englishNegativeResponse: this.state.englishNegativeResponse,
            spanishPositiveResponse: this.state.spanishPositiveResponse,
            spanishNegativeResponse: this.state.spanishNegativeResponse,
          })}
          multiline
          minRows="8"
          className={classes.textField}
          margin="normal"
          variant="filled"
        />
      )
    }
    if (
      this.state.notifySelected === false &&
      this.state.languageSelected === false
    ) {
      spanishPositiveResponseField = (
        <TextField
          name="spanishPositiveResponse"
          id="message_response_positive_es"
          label="Positive Response - Spanish"
          multiline
          minRows="2"
          margin="normal"
          value={this.state.spanishPositiveResponse}
          onChange={this.handleChange.bind(this)}
          className={classes.textField}
          error={this.state.spanishPositiveResponseError}
          helperText={this.state.spanishPositiveResponseErrorMsg}
        />
      )
      spanishNegativeResponseField = (
        <TextField
          name="spanishNegativeResponse"
          id="message_response_negative_es"
          label="Negative Response - Spanish"
          multiline
          minRows="2"
          margin="normal"
          value={this.state.spanishNegativeResponse}
          onChange={this.handleChange.bind(this)}
          className={classes.textField}
          error={this.state.spanishNegativeResponseError}
          helperText={this.state.spanishNegativeResponseErrorMsg}
        />
      )
    }
    return (
      <div className={classes.formBox}>
        <form>
          <br />
          <br />
          {englishPositiveResponseField}
          {englishNegativeResponseField}
          {spanishPositiveResponseField}
          {spanishNegativeResponseField}
          {previewField}
          <br />
        </form>
      </div>
    )
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setEnglishPositiveResponse,
      setEnglishNegativeResponse,
      setSpanishPositiveResponse,
      setSpanishNegativeResponse,
    },
    dispatch,
  )

const mapStateToProps = (state) => ({
  englishPositiveResponse: state.responseCreate.inputEnglishPositiveResponse,
  englishNegativeResponse: state.responseCreate.inputEnglishNegativeResponse,
  spanishPositiveResponse: state.responseCreate.inputSpanishPositiveResponse,
  spanishNegativeResponse: state.responseCreate.inputSpanishNegativeResponse,
})
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(ResponseCreateForm))

ResponseCreateForm.propTypes = {
  classes: object,
  fromParentEnglishPositiveResponseData: string,
  fromParentEnglishNegativeResponseData: string,
  fromParentSpanishPositiveResponseData: string,
  fromParentSpanishNegativeResponseData: string,
  fromParentNotify: bool,
  fromParentLanguageSelectedResponse: bool,
  callbackFromParentEnglishPositiveResponse: func.isRequired,
  callbackFromParentEnglishPositiveResponseData: func.isRequired,
  callbackFromParentEnglishNegativeResponse: func.isRequired,
  callbackFromParentEnglishNegativeResponseData: func.isRequired,
  callbackFromParentSpanishPositiveResponse: func.isRequired,
  callbackFromParentSpanishPositiveResponseData: func.isRequired,
  callbackFromParentSpanishNegativeResponse: func.isRequired,
  callbackFromParentSpanishNegativeResponseData: func.isRequired,
}
